
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";


import { Chart } from "react-google-charts";

import { Loader } from '../../helpers/loader';
import { format, eachDayOfInterval, add, sub, startOfMonth, subMonths } from 'date-fns'
import ExportCal from '../../components/ExportCal'
import { CsvBuilder } from 'filefy';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint, faPlayCircle, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { supabase } from '../../api'
import { penceToCurrency } from "../../helpers/utils";

export const YearOnYear = () => {


  const toDate = startOfMonth(subMonths(new Date(),1))
  const fromDate = add(toDate, { months: -12 })

  const [loading, setLoading] = useState(false)
  const [active, setActive] = useState(false)
  const [complete, setComplete] = useState(false)

  const [data, setData] = useState()
  
  const rangeInWords = () => {
    if (!fromDate || !toDate) return 'Loading...'
    const fromStr = format(fromDate,'dd MMM yyyy')
    const toStr = format(toDate,'dd MMM yyyy')
    if (fromStr === toStr) return fromStr
    return `${fromStr} - ${toStr}`
  }

  const abort = () => {
      setActive(false)
      setComplete(false)
      setLoading(false)
  }


  const loadAll = async () => {

    setActive(true)
    setLoading(true)
    setComplete(false)

     const { data: rows, error } = await supabase.rpc('monthly_category_sales_yoy_last_24_months')

    
    const data = rows.groupBy(r => r.cat)
    console.log(data)

    setData(data)

    setComplete(true)
    
    setLoading(false)
    setActive(false)
  }


  const productivity = (income, units) => {
    if (units === 0) return null; // or handle as "undefined"
    return ((income / 100) / units);
  }

  const percentageChange = (oldValue, newValue) => {
    if (oldValue === 0) {
      return newValue === 0 ? 0 : null;
    }

    const change = ((newValue - oldValue) / oldValue) * 100;
    return change.toFixed(1)
    }


  const exportCSV = () => {
    new CsvBuilder(`Invoice-${rangeInWords()}.csv`)
    .setColumns(headings)
    .addRows(exportTable())
    .exportFile();
  }

  const doPrint = () => {
    window.print()
  }

  const headings = ['Category','Year','Month','Quantity', 'Unit Cost']
  

  const getTotal = (order) => {

    let total = 0

    if (order.order_type === 0) total = order.orderProducts?.reduce(function (acc, row) { return acc + (row.quantity * row.unit_cost) }, 0);
    if (order.order_type === 1) total = order.orderCustoms?.reduce((agg, oc) => agg + oc.unit_cost, 0)

    return total
  }

  let grandTotal = 0
  let approvedTotal = 0
  let unapprovedTotal = 0

  const exportTable = () => {

    grandTotal = 0
    approvedTotal = 0
    unapprovedTotal = 0

    

    const tbl = data.map((order,i) => {

        


        const total = getTotal(order)
        grandTotal += total

        if (order.approved_at) approvedTotal += total
        else unapprovedTotal += total

        const totalString = penceToCurrency(total)

        console.log(order)
        const row = [
            'Invoice',
            order.purchase_order_num,
            format(new Date(order.delivery_dt),'dd/MM/yyyy'),
            order.shop.name,
            order.id,
            totalString,
            'Zero Rated',
            0,
            totalString,
            order.approved_at ? totalString : '',
            !order.approved_at ? totalString : ''
        ]

        

        return row

        

    })
    
    //sort on extra date field
    //tbl = tbl.sort(function(a, b) { return (`${a[8]} ${a[7]}` > `${b[8]} ${b[7]}` ? 1 : -1) })
    // remove date field
    //tbl = tbl.map(t => t.slice(0,-1))
  
    return tbl
  }


  
  

  const drawTable = (category, data) => {


      const rows = []

      

      for (let i=0;i<12;i++) {
        const dt1 = add(fromDate,{months:i-11})
        const dt2 = add(fromDate,{months:i+1})
        
        const year1Found = data.find(d => d.year === dt1.getFullYear() && d.month === dt1.getMonth()+1 )
        const year2Found = data.find(d => d.year === dt2.getFullYear() && d.month === dt2.getMonth()+1 )
        
        const year1 = year1Found || {year: dt1.getFullYear(), month: dt1.getMonth()+1, cat: category, unit_cost_sum: 0, quantity_sum: 0}
        const year2 = year2Found ||  {year: dt2.getFullYear(), month: dt2.getMonth()+1, cat: category, unit_cost_sum: 0, quantity_sum: 0}

        const p1 = productivity(year1.unit_cost_sum, year1.quantity_sum)
        const p2 = productivity(year2.unit_cost_sum, year2.quantity_sum)
        
        const chg = (p1 !==null && p2 !==null) ? percentageChange(p1, p2) : null

        
        
        
        rows.push({dt1,dt2,year1: year1, year2, p1, p2, chg})
      }

      const chartData = [
        ["Month", `${rows[0].year1.year}-${rows[11].year1.year}`, `${rows[0].year2.year}-${rows[11].year2.year}`],
      ]

      rows.forEach(r => {
        chartData.push([
          format(r.dt1,'MMM'),
          r.p1 || 0,
          r.p2 || 0
        ])
      })

      console.log(category, rows, chartData)
      const tbl = [] //exportTable()
      return (
          <>
          <div className='table-wrapper'>
            <h1 style={{textAlign:'center'}}>{category}</h1><br/>
            <table className='right'>
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    {rows.map(r => <th>{format(r.dt1,'MMM')}</th>)}
                  </tr> 
                </thead>
                <tbody>

                    <tr >
                      <th rowSpan='3'>{rows[0].year1.year}-{rows[11].year1.year}</th>
                      <th>units</th>
                      {rows.map(r => <td>{r.year1?.quantity_sum || 0}</td>)}
                    </tr>

                    <tr >
                      <th>total &pound; </th>
                      {rows.map(r => <td>{penceToCurrency(r.year1?.unit_cost_sum || 0, false)}</td>)}
                    </tr>

                    <tr >
                      <th>ppu &pound; </th>
                      {rows.map(r => <td>{r.p1?.toFixed(2)}</td>)}
                    </tr>

                    <tr >
                      <th rowSpan='3'>{rows[0].year2.year}-{rows[11].year2?.year}</th>
                      <th>units</th>
                      {rows.map(r => <td>{r.year2?.quantity_sum || 0}</td>)}
                    </tr>

                    <tr >
                      <th>total &pound;</th>
                      {rows.map(r => <td>{penceToCurrency(r.year2?.unit_cost_sum || 0, false)}</td>)}
                    </tr>

                    <tr >
                      <th>ppu &pound; </th>
                      {rows.map(r => <td>{r.p2?.toFixed(2)}</td>)}
                    </tr>

                    <tr >
                      <th>Change</th>
                      <th>%</th>
                      {rows.map(r => <th className={r.chg < 0 ? 'negative' : 'positive'}><b>{r.chg === null ? '' : (r.chg > 0 ? `+${r.chg}` : `${r.chg}` )}</b></th>)}
                    </tr>

                </tbody>
            </table>
            <Chart
  chartType="LineChart"
      width="100%"
      height="300px"
      options={{
        title: category,
        curveType: "function",
        legend: { position: "bottom" }
      }}
  data={chartData}

/><br/><br/><br/><br/>
          </div>
          </>
      )
  }

  return (
    <>
        
        <div className='outer'>
          <h1 className={''}>Year on Year</h1>
          <h2>{format(fromDate, 'MMMM yyyy')} - {format(toDate, 'MMMM yyyy')}</h2>
          <div className='center'>
            
            {active && <button disabled onClick={abort}><FontAwesomeIcon icon={faSpinner} spin={true} />&nbsp;&nbsp;Processing...</button>}
            {!active && <button onClick={loadAll}><FontAwesomeIcon icon={faPlayCircle} />&nbsp;&nbsp;START LOAD</button>}
          </div>
          
          {loading && <Loader />}
          {data && !active && complete && !loading ? 
          <>
            <ul style={{marginTop:10}} className='button-list'>
              <li><button onClick={doPrint}><FontAwesomeIcon icon={faPrint} />&nbsp;&nbsp;Print</button></li>
            </ul>
            {Object.keys(data).map(k => {

              return drawTable(k, data[k])
            })}
            

            
          </>
          : ''}
        </div>
    </>
  )
}

export default withRouter(YearOnYear);
